import { render, staticRenderFns } from "./TeacherSOSForm.vue?vue&type=template&id=4ba19b3f"
import script from "./TeacherSOSForm.vue?vue&type=script&lang=js"
export * from "./TeacherSOSForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherSOSForm.vue?vue&type=style&index=0&id=4ba19b3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
